import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BasicService } from './basic.service';

@Injectable({
  providedIn: 'root'
})
export class StatisticsService {
  constructor(private http: HttpClient, private basicService: BasicService) {}

  private authHeaders(): any {
    const headers: any = { 'Content-Type': 'application/json' };
    const userData = this.basicService.user_data || this.basicService.getItem('user_data');
    if (userData && (userData.loginToken || userData.apiKey)) {
      headers['Authorization'] = 'Bearer ' + (userData.loginToken || userData.apiKey);
    }
    return headers;
  }

  getStatisticsByBusinessId(body: any) {
    return this.http.post<any>(
      environment.auth_url + '/api/getStatisticsByBusinessId',
      body,
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  getInvoicesReviewedStats(body: { adminId: number; period?: string }) {
    return this.http.post<any>(
      environment.auth_url + '/api/getInvoicesReviewedStats',
      body,
      { headers: this.authHeaders() }
    );
  }
}
